import React, { Component } from 'react';
import { withLocalize, Translate } from 'react-localize-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';
import OldStyleSection from '../../common/oldStyleSection';
import EssCard from './essCard';
import Number from '../../common/numberComponent';

class EconomicGroupAdditionalInfo extends Component {
    state = {
        warningsExpanded: false
    }
    render() {
        if (!this.props.data) { return null };
        let data = this.props.data
        return (
            <OldStyleSection name={this.props.translate("Report.EconomicGroup.TitleAdditionalInformation")} hasData isBold isOpen={false}>
                {this.ecoTable(data.economicInfo, data.publishedFinStatRatio)}
                {data.activeNegativeInfo.length > 0 &&
                    this.warningTable(data.activeNegativeInfo, false, null)}
                {data.historicalNegativeInfo.length > 0 &&
                    this.warningTable(data.historicalNegativeInfo, true, (data.activeNegativeInfo.length > 0 || data.historicalNegativeInfo.length > 0) ? data.legend : null)}
                {(data.grants.length > 0 || data.procurements.length > 0) &&
                    <EssCard title={this.props.translate("Report.EconomicGroup.AiPublicProcurementsGrantsTitle")}>
                        {this.grantsTable(data.grants, true)}
                        {this.grantsTable(data.procurements, false)}
                    </EssCard>}
                {(data.changes.length > 0) &&
                    <EssCard title={this.props.translate("Report.EconomicGroup.AiChangesTitle")}>
                        {this.changesTable(data.changes)}
                    </EssCard>}
            </OldStyleSection>
        )
    }

    ecoTable = (item, publishedFinStatRatio) => {
        if (item === null)
            return null;

        const getValues = (labelTr, arr, prop) => [
            { key: "label", value: this.props.translate(labelTr)},
            ...arr.map((x, i) => ({ key: i, value: <Number fixed value={x[prop] / 1000000000} fractionDigits={2} />, style: { textAlign: "right" } }))
        ];

        const header = [{ key: 0, value: ""}, ...item.map(i => ({ key: i.year, value: `${i.year}${i.isEstimate ? "*" : ""}`, style: { width: "12em", textAlign: "right" } }))];
        const data = [
            { key: "aiRevenues", values: getValues("Report.EconomicGroup.AiRevenues", item, "revenues") },
            { key: "aiAssets", values: getValues("Report.EconomicGroup.AiAssets", item, "assets") },
            { key: "aiProfit", values: getValues("Report.EconomicGroup.AiProfit", item, "profit") },
            { key: "aiPublishedFinStat", values: [
                    { key: "label", value: this.props.translate("Report.EconomicGroup.AiPublishedFinStat") },
                    { key: "value", value: publishedFinStatRatio, colSpan: item.length, style: { textAlign: "right" } }
                ]
            }
        ];

        return (
            <EssCard title={this.props.translate("Report.EconomicGroup.AiBasicEconomicDataTitle")}>
                <OldStyleTableWithHistory tableColumns={1 + item.length} stripped resolveExpanded={this.props.resolveExpanded} actualData={data}
                    head={() => <thead>
                        <tr>
                            {header.map(h => <th key={h.key} style={h.style}>{h.value}</th>)}
                        </tr>
                    </thead>}
                    actualRow={(r) => <tr key={r.key} className="colorize">
                        {r.values.map(v => <td key={v.key} colSpan={v.colSpan} style={v.style}>{v.value}</td>)}
                    </tr>}
                />
                <p><Translate id="Report.EconomicGroup.AiFinStatEstimation" /></p>
            </EssCard>
        )
    }

    warningTable = (item, historical, legend) => {
        if (item === null)
            return null;

        return (
            <EssCard title={this.props.translate(historical ? "Report.EconomicGroup.AiNiHistoricalSubjects" : "Report.EconomicGroup.AiNiCurrentSubjects")}>
                <OldStyleTableWithHistory tableColumns={3} stripped resolveExpanded={this.props.resolveExpanded} actualData={item.map((x, i) => ({ ...x, index: i }))}
                    head={() => <thead>
                        <tr>
                            <th style={{ width: "40%" }}><Translate id="Report.EconomicGroup.AiNiAbbreviation" /></th>
                            <th style={{ width: "30%" }}><Translate id="Search.Common.Count" /></th>
                            <th style={{ width: "30%" }}><Translate id="Report.EconomicGroup.AiNiRatio" /></th>
                        </tr>
                    </thead>}
                    actualRow={(r) => <tr key={r.index}>
                        <td>{r.code}</td>
                        <td>{r.count}</td>
                        <td>{r.share}</td>
                    </tr>}
                />
                <p><Translate id="Report.EconomicGroup.AiNiRatioToAll" /></p>
                {(!isNullOrUndefined(legend)) && <OldStyleSection name={this.props.translate("Report.EconomicGroup.Legend.NI")} hasData isBold isOpen={false}>
                        {this.legendsTable(legend)}
                </OldStyleSection>}
            </EssCard>
        )
    }

    legendsTable = (item) => {
        if (item === null)
            return null;

        return (
            <OldStyleTableWithHistory tableColumns={3} stripped resolveExpanded={this.props.resolveExpanded} actualData={item.map((x, i) => ({ ...x, index: i }))}
                head={() => <thead>
                    <tr>
                        <th><Translate id="Report.EconomicGroup.AiNiAbbreviation" /></th>
                        <th><Translate id="Report.EconomicGroup.Legend.NI.Description" /></th>
                        <th><Translate id="Report.Common.Source" /></th>
                    </tr>
                </thead>}
                actualRow={(r) => <tr key={r.index}>
                    <td>{r.code}</td>
                    <td>{r.description}</td>
                    <td>{r.source}</td>
                </tr>}
            />
        )
    }

    grantsTable = (item, grants) => {
        if (isNullOrUndefined(item) || item.length === 0)
            return null;

        return (
            <OldStyleTableWithHistory tableColumns={4} stripped resolveExpanded={this.props.resolveExpanded} actualData={item.map((x, i) => ({ ...x, index: i }))}
                head={() => <thead>
                    <tr>
                        <th><Translate id={grants ? "Report.EconomicGroup.AiPpgGrants" : "Report.EconomicGroup.AiPpgPublicProcurements"} /></th>
                        <th><Translate id="Report.EconomicGroup.AiPpgAmount" /></th>
                        <th><Translate id={grants ? "Report.EconomicGroup.AiPpgGrantsCount" : "Report.EconomicGroup.AiPpgProcurementsCount"} /></th>
                        <th><Translate id="Report.EconomicGroup.AiPpgSubjectsCount" /></th>
                    </tr>
                </thead>}
                actualRow={(r) => <tr key={r.index}>
                    <td><Translate id="Search.Common.Sum" />({r.currency})</td>
                    <td><Number fixed value={r.volume} fractionDigits={0} /></td>
                    <td>{r.count}</td>
                    <td>{r.subjectCount}</td>
                </tr>}
            />
        )
    }

    changesTable = (item) => {
        if (item === null || item.length === 0)
            return null

        return (
            <OldStyleTableWithHistory tableColumns={3} stripped resolveExpanded={this.props.resolveExpanded} actualData={item.map((x, i) => ({ ...x, index: i }))}
                head={() => <thead>
                    <tr>
                        <th><Translate id="Report.EconomicGroup.AiChanges.Name" /></th>
                        <th><Translate id="Report.EconomicGroup.AiChanges.Count" /></th>
                        <th><Translate id="Report.EconomicGroup.AiChanges.DateLast" /></th>
                    </tr>
                </thead>}
                actualRow={(r) => <tr key={r.index}>
                    <td>{r.description}</td>
                    <td>{r.count}</td>
                    <td>{r.dateFormated}</td>
                </tr>}
            />
        )
    }
}

export default withLocalize(EconomicGroupAdditionalInfo);
